import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import TimeInputOfficeHrs from "../../../../components/TimeInputOfficeHrs";
import { rowForEditOfficeSettings } from "../atoms/atoms";

const OfficeHours = ({ disableFields }) => {
  const rowForEdit = useRecoilValue(rowForEditOfficeSettings);
  const formMethods = useFormContext();
  const [monDisable, setMonDisable] = useState(false);
  const [tueDisable, setTueDisable] = useState(false);
  const [wedDisable, setWedDisable] = useState(false);
  const [thuDisable, setThuDisable] = useState(false);
  const [friDisable, setFriDisable] = useState(false);
  const [satDisable, setSatDisable] = useState(false);
  const [sunDisable, setSunDisable] = useState(false);
  const officeHoursData = [
    {
      dayStoreHrs: "mondayStoreHours",
      startTime: "mondayStartTime",
      endTime: "mondayEndTime",
      setDayStatus: setMonDisable,
    },
    {
      dayStoreHrs: "tuesdayStoreHours",
      startTime: "tuesdayStartTime",
      endTime: "tuesdayEndTime",
      setDayStatus: setTueDisable,
    },
    {
      dayStoreHrs: "wednesdayStoreHours",
      startTime: "wedsStartTime",
      endTime: "wedsEndTime",
      setDayStatus: setWedDisable,
    },
    {
      dayStoreHrs: "thursdayStoreHours",
      startTime: "thursStartTime",
      endTime: "thursEndTime",
      setDayStatus: setThuDisable,
    },
    {
      dayStoreHrs: "fridayStoreHours",
      startTime: "fridayStartTime",
      endTime: "fridayEndTime",
      setDayStatus: setFriDisable,
    },
    {
      dayStoreHrs: "saturdayStoreHours",
      startTime: "satStartTime",
      endTime: "satEndTime",
      setDayStatus: setSatDisable,
    },
    {
      dayStoreHrs: "sundayStoreHours",
      startTime: "sunStartTime",
      endTime: "sunEndTime",
      setDayStatus: setSunDisable,
    },
  ];
  useEffect(() => {
    officeHoursData.forEach((x) => {
      if (rowForEdit?.[x.dayStoreHrs] === "Closed") {
        formMethods.setValue(x.dayStoreHrs, "Closed");
        x.setDayStatus(true);
      } else {
        formMethods.setValue(x.dayStoreHrs, "Open");
        x.setDayStatus(false);
      }
    });
  }, []);

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Office Hours
      </div>

      <div className="grid grid-cols-2 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TimeInputOfficeHrs
            name="mondayStoreHours"
            starttime="mondayStartTime"
            endtime="mondayEndTime"
            dayopen="mondayOpen"
            label="Monday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={monDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.mondayStartTime &&
              formMethods.formState.errors.mondayEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !monDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("mondayStartTime", "");
              formMethods.setValue("mondayEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("mondayStoreHours", "Open");
                setMonDisable(false);
              } else {
                formMethods.setValue("mondayStoreHours", "Closed");
                setMonDisable(true);
              }
            }}
          />
          <TimeInputOfficeHrs
            name="tuesdayStoreHours"
            starttime="tuesdayStartTime"
            endtime="tuesdayEndTime"
            dayopen="tuesdayOpen"
            label="Tuesday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={tueDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.tuesdayStartTime &&
              formMethods.formState.errors.tuesdayEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !tueDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("tuesdayStartTime", "");
              formMethods.setValue("tuesdayEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("tuesdayStoreHours", "Open");
                setTueDisable(false);
              } else {
                formMethods.setValue("tuesdayStoreHours", "Closed");
                setTueDisable(true);
              }
            }}
          />
          <TimeInputOfficeHrs
            name="wednesdayStoreHours"
            starttime="wedsStartTime"
            endtime="wedsEndTime"
            dayopen="wedsOpen"
            label="Wednesday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={wedDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.wedsStartTime &&
              formMethods.formState.errors.wedsEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !wedDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("wedsStartTime", "");
              formMethods.setValue("wedsEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("wednesdayStoreHours", "Open");
                setWedDisable(false);
              } else {
                formMethods.setValue("wednesdayStoreHours", "Closed");
                setWedDisable(true);
              }
            }}
          />
          <TimeInputOfficeHrs
            name="thursdayStoreHours"
            starttime="thursStartTime"
            endtime="thursEndTime"
            dayopen="thursOpen"
            label="Thursday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={thuDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.thursStartTime &&
              formMethods.formState.errors.thursEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !thuDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("thursStartTime", "");
              formMethods.setValue("thursEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("thursdayStoreHours", "Open");
                setThuDisable(false);
              } else {
                formMethods.setValue("thursdayStoreHours", "Closed");
                setThuDisable(true);
              }
            }}
          />
          <TimeInputOfficeHrs
            name="fridayStoreHours"
            starttime="fridayStartTime"
            endtime="fridayEndTime"
            dayopen="fridayOpen"
            label="Friday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={friDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.fridayStartTime &&
              formMethods.formState.errors.fridayEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !friDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("fridayStartTime", "");
              formMethods.setValue("fridayEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("fridayStoreHours", "Open");
                setFriDisable(false);
              } else {
                formMethods.setValue("fridayStoreHours", "Closed");
                setFriDisable(true);
              }
            }}
          />
        </div>
        <div className="space-y-1">
          <TimeInputOfficeHrs
            name="saturdayStoreHours"
            starttime="satStartTime"
            endtime="satEndTime"
            dayopen="satOpen"
            label="Saturday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={satDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.satStartTime &&
              formMethods.formState.errors.satEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !satDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("satStartTime", "");
              formMethods.setValue("satEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("saturdayStoreHours", "Open");
                setSatDisable(false);
              } else {
                formMethods.setValue("saturdayStoreHours", "Closed");
                setSatDisable(true);
              }
            }}
          />
          <TimeInputOfficeHrs
            name="sundayStoreHours"
            starttime="sunStartTime"
            endtime="sunEndTime"
            dayopen="sunOpen"
            label="Sunday Office Hours"
            type="time"
            register={formMethods.register}
            disabled={sunDisable || disableFields}
            disabledStatus={disableFields}
            requiredBorder={
              formMethods.formState.errors.sunStartTime &&
              formMethods.formState.errors.sunEndTime &&
              "border-2 border-red-500 "
            }
            validation={{
              required: {
                value: !sunDisable,
                message: "Required Field",
              },
            }}
            selectOnChange={(e) => {
              formMethods.setValue("sunStartTime", "");
              formMethods.setValue("sunEndTime", "");
              if (e.target.value === "Open") {
                formMethods.setValue("sundayStoreHours", "Open");
                setSunDisable(false);
              } else {
                formMethods.setValue("sundayStoreHours", "Closed");
                setSunDisable(true);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeHours;
